module.exports = __webpack_public_path__ + "images/404.1787648603550.png";